// extracted by mini-css-extract-plugin
module.exports = {"modal":"generalModal_modal__3OhD4","box":"generalModal_box__3PPoK"};